const PROVIDERS_BY_FLAG = {
  ff_auto_fill_consumer_url: 'gitlab',
  ff_funnel_bypass: 'gitlab',
  'ff_imp-4397_product_creation_rakuten': 'gitlab',
  ff_imp_8240_timezone_management: 'gitlab',
  ff_modal_photos_gifted_reviews: 'gitlab',
  ff_photos_gifted_reviews: 'gitlab',
  im_11719_discover_new_creators: 'growthbook',
  imp_6858_creators_statistics: 'gitlab',
  imp_9442_copyrights_rules: 'gitlab',
  imp_9696_copyrighted_content_download: 'gitlab',
  imp_11529_invite_from_creator_profile: 'growthbook',
  imp_11529_invite_from_creator_profile_for_all: 'growthbook',
  imp_10522_more_filters_button: 'gitlab',
  imp_10630_tiktok_shop_targeting: 'gitlab',
  imp_11009_arpp_badge: 'gitlab',
  imp_11190_bulk_accept_reject_orders: 'gitlab',
  imp_11204_social_amplification: 'gitlab',
}

export const getFeatureFlagProvider = flagName =>
  PROVIDERS_BY_FLAG[flagName] || 'gitlab'

export default PROVIDERS_BY_FLAG
